export default {
    urlPrefix: process.env.NODE_ENV === 'production' ? 
    'https://datawang.com/api/v1' : 
    // 'https://datawang.com/api/v1'
    // 'http://localhost:8080/api/v1'
    'http://localhost:8080/api/v1'
}
